module.exports = __webpack_public_path__ + "static/media/career-video.7676f3eb.png";